import { takeLatest, put, call, select } from 'redux-saga/effects';
import { SORT_SAGA } from "../sagaTypes";
import { loaderAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { getPriceSagaAction, getPromoSagaAction, getSubscriptionDataSagaAction } from "../sagaActions";

const request = data => {
    return fetch(`${ url }/fitness_sort`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerSort(args) {
    const user = yield select(state => state.user);
    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('table', args.data.table);
        formData.append('new_order', args.data.new_order);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Обновление прайса
            if (args.data.table === 'price') {
                yield put(getPriceSagaAction());
            }
            // Обновление акций
            else if (args.data.table === 'promo') {
                yield put(getPromoSagaAction());
            }
            // Обновление настроек
            else {
                yield put(getSubscriptionDataSagaAction());
            }
            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherSort() {
    yield takeLatest(SORT_SAGA, workerSort);
}